import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AlertsService } from '../../../../shared/service/alerts.service';
import { SocketService } from '../../../../shared/service/socket.service';
import { AuthService } from '../../../../core/service/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  form: UntypedFormGroup;

  multipleCategory = [
    { geoID: "bottling", name: "Bottling Plant" },
    { geoID: "wbsbcl", name: "WBSBCL Depot" },
    { geoID: "distillery", name: "Distillery" },
    { geoID: "manufactory", name: "CSBP/FL Manufactory" },
  ];
  selectedCategory = []
  categorySettings =
    {
      badgeShowLimit: 1,
      // singleSelection: true,
      text: "Select Category",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,

      classes: "select3",
      labelKey: "name",
      primaryKey: "geoID",
      maxHeight: 200
    };

  multipleMovement = [
    { value: "import", name: "Import of finished packaged liquor" },
    { value: "export", name: "Export of finished package liquor" },
    { value: "domestic", name: "Internal movement of finished package liquor" },
    { value: "transit", name: "Transit movement of finished package liquor" },
    { value: "bottling", name: "Bottling Plant to WBSBCL Depot" },
    { value: "manufactory", name: "Distillery to CSBP or FL Manufactory" },
    { value: "empty", name: "Transit Movement of Empty Tankers" },
    { value: "milk", name: "Transit Movement of Milk Tankers" },
    { value: "oil", name: "Transit Movement of Oil Tankers" },
  ];
  selectedMovement = []
  movementSettings =
    {
      badgeShowLimit: 1,
      text: "Select Movement Type",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,

      classes: "select3",
      labelKey: "name",
      primaryKey: "value",
      maxHeight: 200
    };

  multipleCheckPoint = [];
  selectedCheckPoint = []
  checkPointSettings =
    {
      badgeShowLimit: 1,
      // singleSelection: true,
      // text: "Select Checkpoint",
      text: "Select Location",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,

      classes: "select3",
      labelKey: "name",
      primaryKey: "value",
      maxHeight: 200
    };
  selectedLocationSettings =
    {
      badgeShowLimit: 1,
      // singleSelection: true,
      text: "Select Location",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,

      classes: "select3",
      labelKey: "name",
      primaryKey: "_id",
      maxHeight: 200
    };

  constructor(private formBuilder: UntypedFormBuilder, private alert: AlertsService, private api: AuthService) {

  }

  ngOnInit(): void {
    this.createForm();
    this.getGeofenceData();
    // this.getList()
  }

  createForm() {
    this.form = this.formBuilder.group({
      name: ["", Validators.required],
      company: ["", Validators.required],
      password: new UntypedFormControl("", [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,}$)/)]),
      pan: [""],
      gstin: [""],
      mobileNo: ["", [Validators.required, Validators.pattern(/^\d{10}(,\d{10})*$/)]],
      email: ["", [Validators.required, Validators.pattern(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i)]],
      address: ["", Validators.required],
      city: ["", Validators.required],
      state: ["West Bengal", Validators.required],
      pin: ["", Validators.required],
      category: ["", Validators.required],
      movementType: ["select"],
      geofence: ["select", Validators.required],
      userType: ["user", Validators.required],
      checkPoint: ["select"],
      // selectedLocation: ["select"]
    })

    this.alert.detectFormChanges(this.form);
  }
  multipleGeofences = []
  getGeofenceData() {
    this.multipleCheckPoint = [];
    this.multipleGeofences = [];
    this.api.getGeofenceWithoutLogin({ type: "all", state: this.form.value.state }).subscribe((res: any) => {
      const { success, data, message } = res;

      if (success) {
        data.map((item) => {
          if (item.type != 'checkpoint') {
            this.multipleGeofences.push({ value: item._id, name: item.name, type: item.type });
          }
          this.multipleCheckPoint.push({ value: item._id, name: item.name })
        }); 

      }
      else {
        // this.alert.showToast(message,'error')
      }
    }, (err) => this.alert.showToast(err.message, 'error'))
  }

  checkValidity() {
    const { userType, name, company, mobileNo, email, city, address,
      state, pin, movementType, geofence, designation, checkPoint, category
    } = this.form.value;

    if (this.form.controls.email.valid == false || this.form.controls.password.valid == false || this.form.controls.mobileNo.valid == false) {
      return true;
    }

    if (userType == "user") {
      // || !this.selectedCategory || this.selectedCategory.length == 0
      if (!name || !company || !mobileNo || mobileNo == 0 || !pin || pin == 0 || !email || !address || !city || !state || state == 'select') {
        return true;
      }
      // else {
      //   if (this.selectedMovement.length > 0 && (!this.selectedCheckPoint || this.selectedCheckPoint.length == 0)) {
      //     return true;
      //   }
      //   else {
      //     return false;
      //   }
      // }
    }
    else {
      return true;
    }
  }

  submitForm() {

    const { userType, name, company, mobileNo, email, city, address,
      state, pin, pan, gstin, movementType, geofence, designation, checkPoint, category, password
    } = this.form.value;

    var permissions = {
      "dataEntry": false,
      "sealing": false,
      "unsealingByWeb": false,
      "unsealingByBT": false,
      "sendManualAlert": false,
      "showTamper": false,
      "receiveTamperedAlert": false,
      "receiveSealedAlert": false,
      "receiveTransitAlert": false,
      "receiveReachedAlert": false,
      "receiveUnsealedAlert": false,
      "viewGeofence": false,
      "addGeofence": false,
      "viewAssets": false,
      "addAssets": false,
      "createUser": false,
      appLoginAllowed: false,
      "viewUser": false,
      "viewMap": true
    }

    let obj =
    {
      userType,
      name,
      mobile: mobileNo,
      email,
      company: company ? company.toUpperCase() : company,
      pan,
      gstin,
      city,
      state,
      pincode: pin,
      category: this.selectedCategory,
      address,
      movementType: this.selectedMovement,
      designation,
      checkPoint: this.selectedCheckPoint ? this.selectedCheckPoint : this.form.get('checkPoint').value,
      password,
      approved: false,
      geofences: [],
      permissions,
    }

    this.api.addUserWithoutLogin(obj).subscribe((res: any) => {
      const { success, message } = res
      if (success) {
        this.alert.showToast(message, 'success');
        this.reset();
      }
      else {
        this.alert.showToast(message, 'error')
      }
    }, (err) => this.alert.showToast(err.message, 'error'))

  }

  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which === 46) {
      return false;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\.\s]/.test(input);
  }

  reset() {
    this.form.reset();
    this.form.controls.state.setValue("West Bengal");
    this.alert.resetVormValidity(this.form);
  }

}

